/* eslint-disable */
// Todo Remove linter and uncomment the switch
import { type CertificateProps } from './types'
import JMTCertificate from './JMT'
import RBLCertificate from './RBL'
import RBLCertificate24 from './RBL24'
import BMGCertificate from './BMG'
import { Suspense } from 'react'
import { CERTIFICATE_CHANGE_DATE } from '../../lib/apollo/config'
import RBLCertificate25 from './RBL25'

// Helper function to determine certificate type based on date
const getDateBasedCertificateType = (startDate: string, club: string): string => {
  const campDate = new Date(startDate)
  const season2526 = new Date('2025-09-01')

  if (club === 'rbl') {
    if (campDate >= season2526) {
      return 'RBL25' // New certificate from 01.09.2025
    } else if (CERTIFICATE_CHANGE_DATE && campDate.getTime() > parseInt(CERTIFICATE_CHANGE_DATE)) {
      return 'RBL24'
    } else {
      return 'RBL'
    }
  } else if (club === 'bmg') {
    return 'BMG'
  }

  return 'RBL' // Default
}

const Certificate = (props: CertificateProps) => {
  const { certificate, club } = props

  // Use camp-specific certificate type if set, otherwise use date-based logic
  const certificateType = (certificate.camp as any).certificateType ??
    getDateBasedCertificateType(certificate.camp.start ?? '', club)


  // Render certificate based on type
  switch (certificateType) {
    case 'RBL25':
      return (
        <Suspense fallback='...loading'>
          <RBLCertificate25 {...props} clubImg="/assets/rbl/schule_logo.png" />
        </Suspense>
      )
    case 'RBL24':
      return (
        <Suspense fallback='...loading'>
          <RBLCertificate24 {...props} clubImg="/assets/rbl/schule_logo.png" />
        </Suspense>
      )
    case 'RBL':
      return (
        <Suspense fallback='...loading'>
          <RBLCertificate {...props} clubImg="/assets/rbl/schule_logo.png" />
        </Suspense>
      )
    case 'BMG':
      return (
        <Suspense fallback='...loading'>
          <BMGCertificate {...props} clubImg="/assets/bmg/logo.svg" />
        </Suspense>
      )
    case 'JMT':
      return <JMTCertificate {...props} />
    default:
      // For RBL club, always use the appropriate RBL certificate as fallback
      if (club === 'rbl') {
        const fallbackType = getDateBasedCertificateType(certificate.camp.start ?? '', club)
        if (fallbackType === 'RBL25') {
          return (
            <Suspense fallback='...loading'>
              <RBLCertificate25 {...props} clubImg="/assets/rbl/schule_logo.png" />
            </Suspense>
          )
        } else if (fallbackType === 'RBL24') {
          return (
            <Suspense fallback='...loading'>
              <RBLCertificate24 {...props} clubImg="/assets/rbl/schule_logo.png" />
            </Suspense>
          )
        } else {
          return (
            <Suspense fallback='...loading'>
              <RBLCertificate {...props} clubImg="/assets/rbl/schule_logo.png" />
            </Suspense>
          )
        }
      }
      // For other clubs or if club is not specified, use JMT as fallback
      return <JMTCertificate {...props} />
  }
}

export default Certificate
